import { useStyle } from '@/classify';
import { WebsiteEnv } from '@/constants/website-env';
import { useThumbnail } from '@/hooks/ProductImageCarousel/useThumbnail';
import useIsMobile from '@/hooks/use-is-mobile';
import clsx from 'clsx';
import Image from 'next/image';
import { useMemo } from 'react';
import defaultClasses from './thumbnail.module.css';

const DEFAULT_THUMBNAIL_HEIGHT = 132;
const DEFAULT_THUMBNAIL_WIDTH = 90;

const Thumbnail = props => {
  const classes = useStyle(defaultClasses, props.classes);

  const {
    alt,
    isActive,
    item: { file, label },
    onClickHandler,
    itemIndex,
    version,
    sku,
    showSpecialImage,
    isSpecialImage,
  } = props;

  const talonProps = useThumbnail({
    onClickHandler,
    itemIndex,
  });
  const { handleClick } = talonProps;
  const isMobile = useIsMobile();

  const isDesktop = !isMobile;

  const thumbnailImage = useMemo(() => {
    if (!isDesktop) {
      return null;
    }

    const url = version ? `${file}?version=${version}` : file;
    const isAbsolute = /^(data|http|https)?:/i.test(url);

    return (
      <Image
        width={1022}
        height={1500}
        src={isAbsolute ? url : `${process.env.NEXT_PUBLIC_BASE_PATH}/media/catalog/product/${file}`}
        alt={alt}
        className='h-full w-full object-cover'
        loader={({ src }) => src}
        unoptimized
      />
    );
  }, [file, isDesktop, alt, version]);

  return (
    <span
      className={isActive ? classes.rootSelected : classes.root}
      onClick={handleClick}
      role='button'
      aria-hidden='true'
    >
      {isSpecialImage && showSpecialImage ? (
        <div
          className={clsx(
            'absolute left-0 top-0 z-[1] flex h-full w-full flex-col items-center justify-center gap-y-[5px] bg-black/30 ',
            'pointer-events-none',
            'bg-clip-content',
            'p-2',
          )}
        >
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='50'
            height='27'
            fill='none'
            viewBox='0 0 50 27'
          >
            <g
              fill='#fff'
              clipPath='url(#clip0_13178_35002)'
            >
              <path d='M24.998 0C35.572 0 44.838 5.4 50 13.498c-5.163 8.099-14.428 13.499-25.002 13.499S5.16 21.597-.003 13.498C5.163 5.4 14.425 0 24.998 0m0 23.775c5.812 0 10.525-4.55 10.525-10.16S30.81 3.455 24.999 3.455c-5.811 0-10.525 4.55-10.525 10.16s4.714 10.16 10.525 10.16' />
              <path d='M18.498 10.417a3.18 3.18 0 0 0 2.705 1.479c1.746 0 3.165-1.366 3.165-3.055a3 3 0 0 0-.89-2.122c.49-.1 1-.157 1.521-.157 4.034 0 7.306 3.159 7.306 7.053s-3.272 7.052-7.306 7.052-7.305-3.158-7.305-7.052a6.8 6.8 0 0 1 .804-3.198' />
            </g>
            <defs>
              <clipPath id='clip0_13178_35002'>
                <path
                  fill='#fff'
                  d='M50 0H0v27h50z'
                />
              </clipPath>
            </defs>
          </svg>
          <span className='text-center text-sm leading-5 text-white'>
            {WebsiteEnv.isUnitedKingdom ? 'Colour' : 'Color'} Comparison
          </span>
        </div>
      ) : null}
      {thumbnailImage}
    </span>
  );
};

export default Thumbnail;
